import _regeneratorRuntime from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { circleBounce, circleBounceDataFromParticle } from "../../../Utils/Utils";
import { clamp, getDistance } from "../../../Utils/NumberUtils";
import { ParticlesInteractorBase } from "../../../Core/Utils/ParticlesInteractorBase";

function bounce(p1, p2) {
  circleBounce(circleBounceDataFromParticle(p1), circleBounceDataFromParticle(p2));
}

function destroy(p1, p2) {
  if (!p1.unbreakable && !p2.unbreakable) {
    bounce(p1, p2);
  }

  if (p1.getRadius() === undefined && p2.getRadius() !== undefined) {
    p1.destroy();
  } else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) {
    p2.destroy();
  } else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
    if (p1.getRadius() >= p2.getRadius()) {
      p2.destroy();
    } else {
      p1.destroy();
    }
  }
}

export var Collider = /*#__PURE__*/function (_ParticlesInteractorB) {
  _inherits(Collider, _ParticlesInteractorB);

  var _super = _createSuper(Collider);

  function Collider(container) {
    _classCallCheck(this, Collider);

    return _super.call(this, container);
  }

  _createClass(Collider, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.options.collisions.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(p1) {
        var container, pos1, radius1, query, _iterator, _step, p2, pos2, dist, radius2, distP;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this.container, pos1 = p1.getPosition(), radius1 = p1.getRadius(), query = container.particles.quadTree.queryCircle(pos1, radius1 * 2);
                _iterator = _createForOfIteratorHelper(query);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 15;
                  break;
                }

                p2 = _step.value;

                if (!(p1 === p2 || !p2.options.collisions.enable || p1.options.collisions.mode !== p2.options.collisions.mode || p2.destroyed || p2.spawning)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("continue", 13);

              case 8:
                pos2 = p2.getPosition();

                if (!(Math.round(pos1.z) !== Math.round(pos2.z))) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("continue", 13);

              case 11:
                dist = getDistance(pos1, pos2), radius2 = p2.getRadius(), distP = radius1 + radius2;

                if (dist <= distP) {
                  this.resolveCollision(p1, p2);
                }

              case 13:
                _context.next = 4;
                break;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](2);

                _iterator.e(_context.t0);

              case 20:
                _context.prev = 20;

                _iterator.f();

                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 17, 20, 23]]);
      }));

      function interact(_x) {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }, {
    key: "resolveCollision",
    value: function resolveCollision(p1, p2) {
      switch (p1.options.collisions.mode) {
        case "absorb":
          this.absorb(p1, p2);
          break;

        case "bounce":
          bounce(p1, p2);
          break;

        case "destroy":
          destroy(p1, p2);
          break;
      }
    }
  }, {
    key: "absorb",
    value: function absorb(p1, p2) {
      var container = this.container,
          fps = container.fpsLimit / 1000;

      if (p1.getRadius() === undefined && p2.getRadius() !== undefined) {
        p1.destroy();
      } else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) {
        p2.destroy();
      } else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
        if (p1.getRadius() >= p2.getRadius()) {
          var factor = clamp(p1.getRadius() / p2.getRadius(), 0, p2.getRadius()) * fps;
          p1.size.value += factor;
          p2.size.value -= factor;

          if (p2.getRadius() <= container.retina.pixelRatio) {
            p2.size.value = 0;
            p2.destroy();
          }
        } else {
          var _factor = clamp(p2.getRadius() / p1.getRadius(), 0, p1.getRadius()) * fps;

          p1.size.value -= _factor;
          p2.size.value += _factor;

          if (p1.getRadius() <= container.retina.pixelRatio) {
            p1.size.value = 0;
            p1.destroy();
          }
        }
      }
    }
  }]);

  return Collider;
}(ParticlesInteractorBase);